export const FDLQ_URL = new URL("https://fdlq.crifuq.usherbrooke.ca");
export const FDLQ_DERNIER_CORPUS = "fdlq-corpus";
export const EXEMPLIFICATION_MARQUES_PRÉCISIONS = "exemplification-marquesEtPrécisions";
export const EXEMPLIFICATION_SURLIGNAGE_FORMES = "exemplification-surlignageDesFormes";

export function initDOMListeners() {
    document.addEventListener('DOMContentLoaded', () => {
        Infobulles.associeInfobulles();

        const cbMarquesPrécisions = document.getElementById('afficherMarquesEtPrécisions');
        if (cbMarquesPrécisions) {
            cbMarquesPrécisions.addEventListener('click', commuteMarquesEtPrécisions);
        }

        const cbSurlignage = document.getElementById('surlignerLesFormes');
        if (cbSurlignage) {
            cbSurlignage.addEventListener('click', commuteSurlignageDesFormes);
        }

        initMarqueEtPrécisions(false);
        initSurlignageDesFormes();
        initialiseRechercheFDLQ();
    });

    addEventListener("pageshow", () => {
        initMarqueEtPrécisions();
        initSurlignageDesFormes();
    });
}

export function initMarqueEtPrécisions() {
    const cbMarquesPrécisions = document.getElementById('afficherMarquesEtPrécisions');
    if (!cbMarquesPrécisions) return;

    const affiche = localStorage.getItem(EXEMPLIFICATION_MARQUES_PRÉCISIONS) === 'true';
    const display = affiche ? "inline-flex" : "none";
    cbMarquesPrécisions.checked = affiche;

    document.querySelectorAll(".indicateurs").forEach(élément => {
        élément.style.display = display;
    });
}

export function commuteMarquesEtPrécisions() {
    const checked = Boolean(document.getElementById('afficherMarquesEtPrécisions').checked);
    const display = checked ? "inline-flex" : "none";

    localStorage.setItem(EXEMPLIFICATION_MARQUES_PRÉCISIONS, checked.toString());

    document.querySelectorAll(".indicateurs").forEach(élément => {
        élément.style.display = display;
    });
}

export function initialiseRechercheFDLQ() {
    const fdlqCorpus = document.getElementById('fdlq-corpus');
    if (!fdlqCorpus) return;

    const fdlqDernierCorpus = localStorage.getItem(FDLQ_DERNIER_CORPUS);
    if (fdlqDernierCorpus !== null) {
        const option = document.querySelector(`select option[value='${fdlqDernierCorpus}']`);
        if (option) option.selected = true;
    }

    const enSavoirPlusLienÉlément = document.getElementById("corpus-enSavoirPlus-lien");

    fdlqCorpus.addEventListener('change', (e) => {
        enSavoirPlusLienÉlément.setAttribute("href", e.target.options[e.target.selectedIndex].dataset.url);
    });

    enSavoirPlusLienÉlément.setAttribute("href", fdlqCorpus.options[fdlqCorpus.selectedIndex].dataset.url);


    const rechercheFDLQBouton = document.getElementById('rechercheFDLQ');
    if (!rechercheFDLQBouton) return;
    rechercheFDLQBouton.addEventListener('click', rechercheFDLQ);

}

export function rechercheFDLQ() {
    const motÉlément = document.getElementById('fdlq-mot');
    const optionCourante = motÉlément.selectedOptions[0];
    let typeMot = document.getElementById('fdlq-typeMot').value;
    let mot = motÉlément.value;
    let corpus = document.getElementById('fdlq-corpus').value;

    const isLemme = (typeMot === 'lemma');

    if (isLemme && (mot.startsWith("s'") || mot.startsWith("se "))) {
        mot = mot.replace(/^(s'|s’|se )(.*)/, "$2");
    }

    const graphieLemme = optionCourante.dataset.graphieLemme;
    const classe = optionCourante.dataset.classe;
    const verbePronominalType = optionCourante.dataset.verbePronominalType;

    const modeRecherche = (!isLemme && verbePronominalType === 'essentiellement') ? "OCCURRENCE" : "LEMMA";
    const q = (isLemme || modeRecherche === "OCCURRENCE") ? mot : graphieLemme;
    const fo = (!isLemme && modeRecherche === "LEMMA") ? mot : "";
    const pos = getCatgramFDLQ(classe);

    const rechercheUrl = new URL(FDLQ_URL);
    rechercheUrl.pathname = 'concordancier';
    rechercheUrl.search = new URLSearchParams({
        c3c: 'true',
        ds: 'true',
        dt: 'PHRASE',
        f: `[{"comparator":"equals", "operator":"+", "slug":"corpus_slug", "value": "${corpus}"}]`,
        i: 10,
        lp: 'false',
        p: 1,
        q,
        s: '[]',
        st: modeRecherche,
        po: pos,
        fo
    }).toString();

    window.open(rechercheUrl);
    localStorage.setItem(FDLQ_DERNIER_CORPUS, corpus);
}

export function getCatgramFDLQ(catgramUsito) {
    if (!catgramUsito || catgramUsito.trim().length === 0) return "";

    if (catgramUsito === 'nom') return "NOUN";
    if (catgramUsito.startsWith('adj')) return "ADJ";
    if (catgramUsito.startsWith('verbe')) return "VERB";
    if (catgramUsito.startsWith('adverbe')) return "ADV";
    if (catgramUsito.startsWith('déterm')) return "DET";
    if (catgramUsito.startsWith('pronom')) return "PRON";
    if (catgramUsito.startsWith('conjonction_de_sub')) return "SCONJ";
    if (catgramUsito.startsWith('conjonction_de_co')) return "CCONJ";
    if (catgramUsito === 'conjonction') return "SCONJ";
    if (catgramUsito.startsWith('préposition')) return "ADP";
    if (catgramUsito.startsWith('interjection')) return "INTJ";
    if (catgramUsito.startsWith('nom_propre')) return "PROPN";
    if (catgramUsito.startsWith('mot_latin')) return "X";
    if (catgramUsito.startsWith('locution_verb')) return "PHRASAL_VERB";
    if (catgramUsito.startsWith('locution')) return "PHRASE";

    return catgramUsito;
}


initDOMListeners();

// ─── Surlignage de la forme dans les exemples et citations de l'article (USI-1130) ───────────
//
// La page mêle les exemples dégagés par les lexicographes et des contextes trouvés dans d'autres
// articles, sans dire lequel est lequel ni pourquoi une phrase est là. On surligne donc la forme
// de l'article partout où elle apparaît dans SES exemples et SES citations.
//
// Les contextes venus d'ailleurs sont laissés de côté ici : leur forme déclenchante n'est connue
// que du serveur, qui ne l'expose pas encore. Ils portent la classe « lien-autre-article », qui
// suffit à les écarter.

/**
 * Frontière de mot, en clair plutôt qu'en \p{L}.
 *
 * Deux contraintes du paquetage l'imposent (cf. babel.config.cjs) : la cible descend à iOS 12,
 * qui ignore le lookbehind — d'où le groupe capturant en tête plutôt qu'un (?<!…) — et à
 * Chrome 61, antérieur aux échappements de propriété Unicode. Ne pas « simplifier » ceci en
 * \p{L} ou en lookbehind sans remonter ces cibles : une erreur de syntaxe dans une expression
 * régulière casse le module entier au chargement, pas seulement le surlignage.
 */
const LETTRES = "A-Za-z0-9À-ÖØ-öø-ÿŒœŸ";

/** Toutes les apostrophes possibles se valent : l'index les normalise, pas le texte affiché. */
const APOSTROPHES = "['’‘‛`´]";

/**
 * Le surlignage est une option, éteinte par défaut et mémorisée comme « marques et précisions ».
 *
 * Les <mark> sont construits à l'activation et retirés à l'extinction, plutôt que masqués en
 * CSS : un <mark> invisible reste un passage signalé pour un lecteur d'écran, qui l'annoncerait
 * sur chaque forme sans que rien ne se voie.
 */
export function initSurlignageDesFormes() {
    const cbSurlignage = document.getElementById('surlignerLesFormes');
    if (!cbSurlignage) return;

    const actif = localStorage.getItem(EXEMPLIFICATION_SURLIGNAGE_FORMES) === 'true';
    cbSurlignage.checked = actif;
    appliqueSurlignageDesFormes(actif);
}

export function commuteSurlignageDesFormes() {
    const actif = Boolean(document.getElementById('surlignerLesFormes').checked);

    localStorage.setItem(EXEMPLIFICATION_SURLIGNAGE_FORMES, actif.toString());
    appliqueSurlignageDesFormes(actif);
}

/** Toujours retirer avant de poser : garantit qu'une double activation ne double pas le balisage. */
function appliqueSurlignageDesFormes(actif) {
    retireSurlignageDesFormes();
    if (actif) {
        surligneLesFormes();
    }
}

function retireSurlignageDesFormes() {
    document.querySelectorAll('mark.forme-article').forEach(marque => {
        const parent = marque.parentNode;
        parent.replaceChild(document.createTextNode(marque.textContent), marque);
        // Refusionne les nœuds de texte voisins, sans quoi une extinction suivie d'une activation
        // découperait le texte un peu plus à chaque fois.
        parent.normalize();
    });
}

export function surligneLesFormes() {
    surligneContextesPropres();
    surligneContextesExternes();
}

/**
 * Dans les exemples et citations de l'article, tout le tableau des formes s'applique : c'est son
 * mot, sous n'importe laquelle de ses formes.
 */
function surligneContextesPropres() {
    const entrées = Array.isArray(window.formesArticle) ? window.formesArticle : [];
    const motif = construitMotifDesFormes(entrées.map(entrée => String(entrée).split(',')[0]));
    if (!motif) return;

    document
        .querySelectorAll('.exemples a:not(.lien-autre-article), .citations a:not(.lien-autre-article)')
        .forEach(lien => surligneDans(lien, motif));
}

/**
 * Un contexte venu d'un autre article ne signale que la graphie qui l'a fait remonter, portée par
 * le serveur dans « data-formes ». Lui appliquer tout le tableau des formes surlignerait des mots
 * qui ne justifient pas sa présence, et le tableau de la page est de toute façon le mauvais : il
 * écarte les formes non visibles, que la recherche de contextes exploite.
 */
function surligneContextesExternes() {
    document
        .querySelectorAll('.exemples a.lien-autre-article[data-formes], .citations a.lien-autre-article[data-formes]')
        .forEach(lien => {
            const motif = construitMotifDesFormes(lien.dataset.formes.split('|'));
            if (motif) surligneDans(lien, motif);
        });
}

/**
 * Une seule expression régulière pour toutes les formes, les plus longues d'abord : sans ce tri,
 * « chat » l'emporterait sur « chattes » et n'en surlignerait que le début.
 *
 * @param graphies graphies à repérer, telles quelles
 * @returns {RegExp|null} null si aucune graphie n'est exploitable
 */
export function construitMotifDesFormes(graphies) {
    const alternatives = graphies
        .map(échappeForme)
        .filter(forme => forme !== null)
        .sort((a, b) => b.length - a.length);

    if (alternatives.length === 0) return null;

    return new RegExp(`(^|[^${LETTRES}])(${alternatives.join('|')})(?![${LETTRES}])`, 'gi');
}

function échappeForme(graphie) {
    const forme = String(graphie).trim();
    if (forme.length === 0) return null;

    return forme
        .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        .replace(/['’‘‛`´]/g, APOSTROPHES);
}

/** Parcourt les nœuds de texte : on n'insère jamais de balisage par expression régulière. */
function surligneDans(élément, motif) {
    const noeuds = [];
    const parcours = document.createTreeWalker(élément, NodeFilter.SHOW_TEXT);
    while (parcours.nextNode()) {
        noeuds.push(parcours.currentNode);
    }
    noeuds.forEach(noeud => surligneNoeud(noeud, motif));
}

function surligneNoeud(noeud, motif) {
    const texte = noeud.nodeValue;
    const occurrences = [];

    motif.lastIndex = 0;
    let trouvé;
    while ((trouvé = motif.exec(texte)) !== null) {
        const début = trouvé.index + trouvé[1].length;
        occurrences.push({début, fin: début + trouvé[2].length});
        if (motif.lastIndex === trouvé.index) motif.lastIndex++;
    }

    if (occurrences.length === 0) return;

    const fragment = document.createDocumentFragment();
    let position = 0;
    occurrences.forEach(({début, fin}) => {
        if (début > position) {
            fragment.appendChild(document.createTextNode(texte.slice(position, début)));
        }
        const marque = document.createElement('mark');
        marque.className = 'forme-article';
        marque.textContent = texte.slice(début, fin);
        fragment.appendChild(marque);
        position = fin;
    });
    if (position < texte.length) {
        fragment.appendChild(document.createTextNode(texte.slice(position)));
    }

    noeud.parentNode.replaceChild(fragment, noeud);
}
